export const userPoolId = 'us-west-2_k6aHEB5Es';

export const clientId = '5cqv6l76d057ms59dbvltqp3p6'

export const apiURL = "https://dev-api.correlator.aip.corrprocanada.com/adc/"